import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface SubscriptionContextType {
  isBlocked: boolean;
  blockMessage: string | null;
  setBlocked: (blocked: boolean, message?: string) => void;
}

const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription must be used within SubscriptionProvider');
  }
  return context;
};

interface SubscriptionProviderProps {
  children: ReactNode;
}

export const SubscriptionProvider: React.FC<SubscriptionProviderProps> = ({ children }) => {
  const [isBlocked, setIsBlocked] = useState(false);
  const [blockMessage, setBlockMessage] = useState<string | null>(null);

  const setBlocked = (blocked: boolean, message?: string) => {
    setIsBlocked(blocked);
    setBlockMessage(message || null);
  };

  // Verificar localStorage ao montar (para persistir bloqueio mesmo após refresh)
  useEffect(() => {
    const blocked = localStorage.getItem('subscriptionBlocked');
    const message = localStorage.getItem('subscriptionBlockMessage');
    if (blocked === 'true') {
      setIsBlocked(true);
      setBlockMessage(message);
    }
  }, []);

  // Salvar no localStorage quando mudar
  useEffect(() => {
    if (isBlocked) {
      localStorage.setItem('subscriptionBlocked', 'true');
      if (blockMessage) {
        localStorage.setItem('subscriptionBlockMessage', blockMessage);
      }
    } else {
      localStorage.removeItem('subscriptionBlocked');
      localStorage.removeItem('subscriptionBlockMessage');
    }
  }, [isBlocked, blockMessage]);

  return (
    <SubscriptionContext.Provider value={{ isBlocked, blockMessage, setBlocked }}>
      {children}
    </SubscriptionContext.Provider>
  );
};




